<template>
  <BasicModal
    :width="'960px'"
    :title="getTitle()"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="-container disp-scroll" v-if="isExistInterview">
      <p>採用フロー</p>
      <table class="table-box">
        <tr>
          <th class="table-box-header" style="max-width: 180px; width: 180px;">ステージ</th>
          <th class="table-box-header" style="max-width: 180px; width: 180px;">ステータス</th>
        </tr>
        <tr>
          <td>
            <!-- 採用フロー:ステージ -->
            <template v-if="recruitmentFlows.length > 0">
              <select class="select"
                v-model="seeker.recruitment_flow_stage"
                @change="changeRecruitmentFlow(seeker)">
                  <option v-for="(stg, keyStg) in recruitmentFlows[0].stages"
                    v-bind:value="stg.pk"
                    :key="keyStg">
                      {{ stg.name }}
                  </option>
              </select>
            </template>
          </td>
          <td>
            <!-- 採用フロー:ステータス -->
            <template v-if="recruitmentFlows.length > 0">
              <select class="select" v-model="seeker.recruitment_flow_status" @change="changeRecruitmentFlow(seeker)" :disabled="!getRecruitmentFlowStatus(seeker.recruitment_flow_stage)">
                <option v-for="(sts, keySts) in getRecruitmentFlowStatus(seeker.recruitment_flow_stage)" v-bind:value="sts.pk" :key="keySts">
                    {{ sts.name }}
                </option>
              </select>
            </template>
          </td>
        </tr>
      </table>
      <hr>
      <div class="input-field" v-for="(content, idx) in getInterview" :key="idx">
        <div class="-menu">
          <div>
            <p>質問<b>{{(Number(content.content.order) + 1)}}</b>のタイトル</p>
            <p>タイトル：{{content.content.name}}</p>
            <p style="font-size: 13px; color: #666;">評価コメント以外をクリックすると既読になります。</p>
          </div>
          <b-dropdown aria-role="list" v-if="content.answer.answer_recording">
            <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                <span>再生速度 × {{speedRate}}</span>
                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
            </button>
            <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.0, idx)">× 1.0</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.2, idx)">× 1.2</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.5, idx)">× 1.5</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(1.7, idx)">× 1.7</b-dropdown-item>
            <b-dropdown-item aria-role="listitem" @click="changeSpeedRate(2.0, idx)">× 2.0</b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="video-wrapper">
          <table class="table-box">
            <tr>
              <th class="table-box-header" style="max-width: 64px; width: 64px;"></th>
              <th class="table-box-header">名前</th>
              <th class="table-box-header">回答</th>
              <th class="table-box-header">評価コメント</th>
              <th class="table-box-header">再再生の理由</th>
            </tr>
            <template v-if="content.answer.answer_recording">
              <tr @click="updateRecordingReadAnswer(content.answer)">
                <td style="text-align: center;">
                  <p style="color: #a22;" v-if="getUnread(content.answer.read_user)">未</p>
                  <p style="color: #666;" v-else>既</p>
                </td>
                <td>
                  <div v-if="content.answer.seeker">
                    <p>
                      {{content.answer.seeker_data.name}}
                    </p>
                    <p style="font-size: 13px; color: #666;">
                      {{content.answer.seeker_data.email}}
                    </p>
                    <p style="font-size: 13px; color: #666;">
                      {{new Date(content.answer.created_at).toLocaleString()}}
                    </p>
                  </div>
                  <div v-else>
                    <p>
                      {{content.answer.answer_name}}
                    </p>
                    <p style="font-size: 13px; color: #666;">
                      {{content.answer.answer_email}}
                    </p>
                    <p style="font-size: 13px; color: #666;">
                      {{new Date(content.answer.created_at).toLocaleString()}}
                    </p>
                  </div>
                </td>
                <td style="min-width: 180px; max-width: 180px; text-align: center;">
                  <RecordingVideoTag
                    v-if="content.answer.answer_recording"
                    :index="index + '-' + idx"
                    :video="content.answer.answer_recording"
                  />
                  <div v-else>
                    <p>制限時間内に回答されなかったため、録画されておりません。</p>
                  </div>
                </td>
                <td @mouseover="isOverModifyArea=true" @mouseleave="isOverModifyArea=false">
                  <star-rating
                    style="font-size: 12px; margin-top: 0; color: yellow;"
                    :increment="0.5"
                    v-model="content.answer.rate"
                    :star-size="24"
                    :show-rating="false"
                  />
                  <textarea
                    style="min-height: 88px;"
                    class="textarea"
                    placeholder="評価を記載"
                    maxlength="500"
                    v-model="content.answer.comment"
                  />
                  <button class="button is-small -top-8px" @click="updateRecordingAnswer(content.answer, idx)">
                    評価内容を保存
                  </button>
                  <div style="width:100px; float:right; font-size:12px; margin:8px 0 0 8px;">
                    評価最終更新者：<br>
                    <template v-if="content.answer.comment_user_data">{{content.answer.comment_user_data.username}}</template>
                    <template v-else>-</template>
                  </div>
                </td>
                <td>
                  <p style="color: silver; font-weight: normal;" v-if="content.answer.reason_replay === 'undefined'">
                    1度しか再生されておりません。
                  </p>
                  <p style="font-weight: normal;" v-else>
                    {{content.answer.reason_replay}}
                  </p>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="5">
                  <p>
                    回答データがございません。
                  </p>
                </td>
              </tr>
            </template>
          </table>
        </div>
        <hr>
      </div>
    </div>
    <div class="-container" v-else>
      <div class="-menu">
        <div>
          <p>まだ回答はございません。</p>
        </div>
      </div>
    </div>    <!-- フッターアクション -->
    <div class="footer-box">
      <button
        class="button is-primary"
        @click="changeIndex(-1)"
        :disabled="isMinIndex">
        <span class="mdi mdi-chevron-left -right-8px"></span>
        前の面接へ
      </button>
      <button
        class="button"
        @click="cancel">
        閉じる
      </button>
      <button
        class="button is-primary"
        @click="changeIndex(1)"
        :disabled="isMaxIndex">
        <span class="mdi mdi-chevron-right -right-8px"></span>
        次の面接へ
      </button>
    </div>
  </BasicModal>
</template>

<script>
import { mapState }      from 'vuex'
import BasicModal        from '@/components/Modals/BasicModal'
import RecordingVideoTag from '@/components/VideoView/organisms/RecordingVideoTag'
import StarRating        from 'vue-star-rating'

export default {
  components: {
    BasicModal,
    RecordingVideoTag,
    StarRating,
  },
  props: {
    isShowModal: {
      type: Boolean,
      default: false,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    seeker:   {
      type: Object,
      requierd: true
    },
    recruitmentFlows: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      video: null,
      index: 0,
      speedRate: 1.0,
      isOverModifyArea: false,
      seekerInterview: []
    }
  },
  computed: {
    isMaxIndex () {
      if (this.seekerInterview.length > 0) {
        return this.index === this.seekerInterview.length - 1
      } else {
        return true
      }
    },
    isMinIndex () {
      return this.index === 0
    },
    isExistInterview () {
      if (this.seekerInterview.length > 0) {
        return true
      } else {
        return false
      }
    },
    getInterview () {
      if (this.seekerInterview.length > 0) {
        return this.seekerInterview[this.index].contents
      } else {
        return []
      }
    }
  },
  watch: {
    index () {
      this.speedRate = 1.0
    },
    "seeker.id" () {
      this.setInterviewDatas()
    },
  },
  methods: {
    setInterviewDatas () {
      // 紐付き回答動画を取得する
      if (this.seeker) {
        this.$store.dispatch('directtalk/getRecordingAnswerSeeker', this.seeker.id)
          .then((answerList) => {
            // 面接を軸に再構築する
            this.seekerInterview = []
            let interviewList = []

            // rootになるinterview収集
            for (const interview of answerList) {
              if (interviewList.filter(record => record.id === interview.recording_interview.id).length <= 0) {
                interviewList.push(interview.recording_interview)
              }
            }
            // interviewごとのcontentとanswerを収集
            for (const interview of interviewList) {
              let contentList = []
              // interviewにぶら下がる回答コンテンツを収集
              for (const content of answerList) {
                if (interview.id === content.recording_interview.id) {
                  // 回答データ以外を削除する
                  let answer = this.$_.cloneDeep(content)
                  delete answer.recording_interview
                  delete answer.recording_content

                  contentList.push(
                    {
                      content: content.recording_content,
                      answer : answer
                    }
                  )
                }
              }
              // contentListをcontentのorderでソートする
              const contentTemp = this.$_.orderBy(contentList, ['content.order'], ['asc'])
              // interviewとcontent & anserをくっつける
              this.seekerInterview.push(
                {
                  interview: interview,
                  contents : contentTemp
                }
              )
            }
          })
      }
    },
    getUnread (users) {
      return !this.$_.includes(users, this.user.userHash)
    },
    getTitle () {
      if (this.seekerInterview) {
        if (this.seekerInterview[this.index]) {
          return this.seekerInterview[this.index].interview.name + '（質問数：' + this.seekerInterview[this.index].contents.length + '）'
        } else {
          return '-'
        }
      }
    },
    cancel () {
      this.seekerInterview = []
      this.$emit('close')
    },
    changeSpeedRate (rate, idx) {
      this.$nextTick(() => {
        let video = document.getElementById('question-' + this.index + '-' + idx)
        video.playbackRate = rate
        this.speedRate = rate
      })
    },
    changeIndex (delta) {
      const res = delta + this.index
      const max = this.seekerInterview.length - 1
      if (res < 0) {
        this.index = max
      } else if (res > max) {
        this.index = 0
      } else {
        this.index = res
      }
    },
    updateRecordingAnswer (answer, idx) {
      let data = this.$_.cloneDeep(answer)
      data.comment_user = this.user.userHash
      this.$emit('update-recording-answer', data)
    },
    updateRecordingReadAnswer (answer) {
      let data = this.$_.cloneDeep(answer)
      if (this.isOverModifyArea) {
        return
      }
      this.$emit('update-recording-read-answer', data)
    },
    changeRecruitmentFlow (skData) {
      this.$emit('change-recruitment-flow', skData)
    },
    getRecruitmentFlowStatus (stg) {
      if (!stg || this.recruitmentFlows.length === 0) return null
      for (let re of this.recruitmentFlows[0].stages) {
        if (re.pk === stg) return re.status
      }
      return null
    },
    getRecruitmentFlowActions (sts) {
      if (!sts || this.recruitmentFlows.length === 0) return null
      for (let i in this.recruitmentFlows[0].stages) {
        for (let re of this.recruitmentFlows[0].stages[i].status) {
          if (re.pk === sts) return re.actions
        }
      }
      return null
    },
    openActionCheckModal (data) {
      this.$emit('openActionCheckModal', data)
    },
    openActionTableModal (data) {
      this.$emit('openActionTableModal', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.-container {
  padding: 24px;
  height: 75vh;
}
.input-field {
  padding: 8px;
  text-align: left;
  p {
    font-weight: 600;
    margin-bottom: 8px;
  }
  .-menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 30%;
  }
}
.table-box {
  width: 100%;
  td {
    padding: 8px;
  }
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
  text-align: center;
}
.video-wrapper {
  position: relative;
  width: 100%;
  /deep/ .video-back {
    width: 100%;
    max-height: 160px;
  }
  .question-title {
    position: absolute;
    font-size: 32px;
    top: 0;
    left: 0;
    color: white;
    padding: 4px 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoView/organisms/ModalViewInterview.vue